export default __webpack_public_path__ + "static/media/parajos_tagliattelle.5662e2f6.jpg";